// DEV-ONLY: a mockup of the Feed with Instagram's feel: no boxes, people first, one strong visual where it's earned.
// Open http://localhost:3000/?feedInsta  (never active in a production build)
import React, { useState } from 'react';
import BetLike from '../components/BetLike';
import { TeamAvatar } from '../components/pools/poolFx';

const ROWS_SHOWN = 3;
const money = (n) => `$${(+n).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const logo = (a) => `https://assets.nhle.com/logos/nhl/svg/${a}_light.svg`;

const bet = (team, pick, game, stake, odds) => ({ team, pick, game, stake, odds });
const THIRTEEN = [
  bet('MTL', 'Montréal to win', 'Montréal vs Boston', 1000, 2.15), bet('WPG', 'Winnipeg +1.5', 'Florida vs Winnipeg', 1000, 3.31), bet('VGK', 'Vegas -1.5', 'Vegas vs New Jersey', 1000, 2.6),
  bet('TOR', 'Toronto to win', 'Toronto vs Ottawa', 800, 1.95), bet('OTT', 'Ottawa +1.5', 'Toronto vs Ottawa', 800, 1.8), bet('EDM', 'Edmonton -1.5', 'Edmonton vs Vancouver', 700, 2.75),
  bet('VAN', 'Vancouver +1.5', 'Edmonton vs Vancouver', 700, 1.7), bet('FLA', 'Florida to win', 'Florida vs Winnipeg', 600, 1.85), bet('NJD', 'New Jersey to win', 'Vegas vs New Jersey', 500, 3.72),
  bet('CGY', 'Calgary to win', 'Calgary vs Seattle', 500, 1.8), bet('SEA', 'Seattle +1.5', 'Calgary vs Seattle', 500, 2.6), bet('BOS', 'Boston +1.5', 'Montréal vs Boston', 400, 1.9), bet('TOR', 'Toronto -1.5', 'Toronto vs Ottawa', 400, 2.9),
];
const POSTS = [
  { id: 1, user: 'Chungussifu', ago: '5 min', text: 'won a bet', win: { amount: 4500, color: '#AF1E2D', team: 'MTL', pick: 'Montréal to win', how: '$1,500.00 @ 3.00' }, likes: 12 },
  { id: 2, user: 'DI4N3', ago: '9 min', text: 'bet $40.00', bets: [bet('SEA', 'Seattle +1.5', 'Calgary vs Seattle', 40, 2.6)] },
  { id: 3, user: 'CL34RY', ago: '20 min', text: 'placed 13 bets for $8,900.00', bets: THIRTEEN },
  { id: 4, user: 'Marc88', ago: '1 h', text: 'won Predict the Night', win: { amount: 125, small: true, logos: ['VGK', 'FLA', 'WSH', 'BOS'] }, likes: 5 },
  { id: 5, user: 'Marc88', ago: '2 h', text: 'placed 2 bets for $180.00', bets: [bet('NJD', 'New Jersey to win', 'Vegas vs New Jersey', 120, 3.72), bet('EDM', 'Edmonton to win', 'Edmonton vs Vancouver', 60, 1.65)] },
  { id: 6, user: 'DI4N3', ago: '3 h', text: 'hit The Spin', win: { amount: 300, small: true, art: '/slot/stanley-cup.png' }, likes: 6 },
  { id: 7, user: 'Marc88', ago: '3 h', text: 'won a bet', win: { amount: 55.8, small: true, team: 'VGK', pick: 'Vegas to win', how: '$15.00 @ 3.72' }, likes: 2 },
  { id: 8, user: 'Chungussifu', ago: '4 h', text: 'bet $75.00', bets: [bet('TOR', 'Toronto to win', 'Toronto vs Ottawa', 75, 2.05)] },
];
const PEOPLE = ['CL34RY', 'Chungussifu', 'DI4N3', 'Marc88', 'Sam', 'Max', 'Alex'];

function Flamed({ start, className, children }) {
  const [liked, setLiked] = useState(false);
  return <BetLike className={className} liked={liked} count={start + (liked ? 1 : 0)} onToggle={() => setLiked(!liked)}>{children}</BetLike>;
}

function Bets({ bets }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="fi-rows">
        {(open ? bets : bets.slice(0, ROWS_SHOWN)).map((b, i) => (
          <Flamed key={i} start={0} className="feed-row">
            <img className="feed-logo" src={logo(b.team)} alt="" width="30" height="30" />
            <div className="feed-row-main"><b>{b.pick}</b><span>{b.game}</span></div>
            <div className="feed-row-money"><b>{money(b.stake)}</b><span>@ {b.odds.toFixed(2)}</span></div>
          </Flamed>
        ))}
      </div>
      {bets.length > ROWS_SHOWN && <button type="button" className="fi-more" onClick={() => setOpen(!open)}>{open ? 'Show less' : `Show ${bets.length - ROWS_SHOWN} more`}</button>}
    </>
  );
}

function Win({ win, likes }) {
  if (!win.small) {
    return (
      <Flamed start={likes} className="fi-winwrap">
        <div className="fi-big" style={{ background: win.color }}>
          <img src={logo(win.team)} alt="" />
          <strong>{money(win.amount)}</strong>
          <p>{win.pick}<small>{win.how}</small></p>
        </div>
      </Flamed>
    );
  }
  return (
    <Flamed start={likes} className="fi-winwrap">
      <div className="fi-small">
        <div>
          <strong>{money(win.amount)}</strong>
          {win.pick && <p>{win.pick}<small>{win.how}</small></p>}
        </div>
        {win.team && <img className="fi-mark" src={logo(win.team)} alt="" />}
        {win.art && <img className="fi-mark" src={win.art} alt="" />}
        {win.logos && <span className="fi-marks">{win.logos.map((a) => <img key={a} src={logo(a)} alt="" />)}</span>}
      </div>
    </Flamed>
  );
}

export default function FeedInsta() {
  return (
    <div className="fi-page">
      <style>{CSS}</style>
      <div className="fi-top"><h2>Feed</h2><span className="feed-live"><i />LIVE</span></div>
      <div className="fi-people">
        {PEOPLE.map((n) => <span key={n}><TeamAvatar team={null} name={n} size={52} /><small>{n}</small></span>)}
      </div>
      {POSTS.map((p) => (
        <article key={p.id} className="fi-post">
          <header>
            <TeamAvatar team={null} name={p.user} size={36} />
            <p><b>{p.user}</b> {p.text}</p>
            <time>{p.ago}</time>
          </header>
          {p.bets ? <Bets bets={p.bets} /> : <Win win={p.win} likes={p.likes} />}
        </article>
      ))}
    </div>
  );
}

const CSS = `
.fi-page { max-width: 560px; min-height: 100vh; margin: 0 auto; padding-bottom: 40px; background: var(--fl-surface, #fff); }
.fi-top { display: flex; align-items: center; gap: 10px; padding: 14px 16px 6px; }
.fi-top h2 { margin: 0; font-family: var(--fl-display); font-size: 28px; font-weight: 800; text-transform: uppercase; }
.fi-people { display: flex; gap: 14px; overflow-x: auto; padding: 8px 16px 14px; scrollbar-width: none; }
.fi-people::-webkit-scrollbar { display: none; }
.fi-people > span { flex: none; display: flex; flex-direction: column; align-items: center; gap: 4px; width: 62px; }
.fi-people small { max-width: 100%; color: var(--text-muted); font-size: 11px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.fi-post { padding: 14px 0 10px; border-top: 1px solid var(--fl-line); }
.fi-post header { display: flex; align-items: center; gap: 10px; padding: 0 16px; }
.fi-post header p { flex: 1; min-width: 0; margin: 0; font-size: 14px; }
.fi-post time { flex: none; color: var(--text-muted); font-size: 12px; }
.fi-rows { margin-top: 6px; padding: 0 16px; }
.fi-rows .feed-row:first-child { border-top: 0; }
.fi-more { display: block; margin: 2px 0 0 56px; padding: 4px 0; border: 0; background: none; color: var(--text-muted); font-size: 13px; font-weight: 600; cursor: pointer; }
.fi-winwrap { position: relative; margin-top: 10px; }
.fi-winwrap > .bet-like { margin: 6px 0 0 12px; padding: 2px 4px; }
.fi-big { position: relative; overflow: hidden; padding: 26px 16px 22px; color: #fff; }
.fi-big > img { position: absolute; top: 50%; right: -18px; width: 150px; height: 150px; padding: 22px; box-sizing: border-box; border-radius: 50%; background: #fff; object-fit: contain; transform: translateY(-50%); }
.fi-big strong { position: relative; display: block; font-family: var(--fl-display); font-size: 68px; font-weight: 800; line-height: 1; }
.fi-big p { position: relative; margin: 8px 0 0; font-size: 15px; font-weight: 700; }
.fi-big p small, .fi-small p small { display: block; font-size: 12px; font-weight: 400; opacity: 0.8; }
.fi-small { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 0 16px 0 62px; }
.fi-small strong { display: block; color: var(--win, #16a34a); font-family: var(--fl-display); font-size: 38px; font-weight: 800; line-height: 1.05; }
.fi-small p { margin: 2px 0 0; font-size: 14px; font-weight: 700; }
.fi-mark { width: 56px; height: 56px; object-fit: contain; }
.fi-marks { display: flex; gap: 4px; }
.fi-marks img { width: 30px; height: 30px; object-fit: contain; }
.fi-winwrap:has(.fi-small) > .bet-like { margin-left: 58px; }
@media (max-width: 480px) { .fi-big strong { font-size: 48px; } .fi-big > img { width: 110px; height: 110px; padding: 16px; } }
`;
